interface AvatarProps {
  firstName: string;
  lastName: string;
  thumb: string | undefined;
  size?: number; //  Size of the avatar
  backgroundColor?: string; //  Background color
  textColor?: string; //  Text color
}

function Avatar({
  firstName,
  lastName,
  thumb,
  size = 32,
  backgroundColor = '#f5e6f9',
  textColor = '#861d80',
}: AvatarProps) {
  const initials = `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;

  return (
    <div
      className="avatar"
      style={{
        width: size,
        height: size,
        backgroundColor,
        color: textColor,
        fontSize: size / 2.5,
      }}
    >
      {thumb ? (
        <img
          src={thumb}
          alt={`${firstName} ${lastName}'s avatar`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
          }}
        />
      ) : (
        <div className="avatar-text">{initials}</div>
      )}
    </div>
  );
}

export default Avatar;
